// extracted by mini-css-extract-plugin
module.exports = {"Takeoff":"Takeoff_Takeoff__2zO23","Title":"Takeoff_Title__M-0SG","Img":"Takeoff_Img__2VQLM","Btn":"Takeoff_Btn__3NMTT"};